module.exports = __webpack_public_path__ + "img/cart-top-tip2.b2c2cb71.png";